import { getInitialValues, mobileValidation, onlyNumbersInput, requiredMessage } from "@/lib/utils";
import AuthService from "@/services/api/auth/auth";
import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import toast from "@/lib/toast";
import MapView from "@/components/Map/MapView";
import { useDrawer } from "@/components/Drawer/context/DrawerContext";
import styles from "./Retailer.module.scss";
import Modal from "@/components/Modal/Modal";
import { Tooltip } from "@mui/material";
import { VALIDATION_ERROR_MESSAGES } from "@/lib/constants";
import formRenderer from "@/lib/formRenderer";
import { emailRegex, mobileRegex, zipCodeRegex } from "@/lib/regex";
import Table from "@/components/Table/Table";
import { useDistributor } from "../context/DistributorIDcontext";
import RetailerDetailsDrawer from "./RetailerDetailsDrawer/RetailerDetailsDrawer";
import CustomHeader from "@/components/CustomHeader/CustomHeader";
import Pagination from "@/components/Table/Pagination";
import { useSearchPagination } from "@/hooks/useSearchPagination";
import LinkIcon from "@mui/icons-material/Link";

interface RetilerRow {
  RetailerShopName: string;
  PersonName: string;
  Designation: string;
  Email: string;
  PhoneNumber: string;
  Action: string;
}

const Retailer: React.FC = () => {
  const { setDistributorId } = useDistributor();
  const { openDrawer } = useDrawer();
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [Localities, setLocalities] = useState<any[]>([]);
  const [attendanceData, setAttendanceData] = useState<RetilerRow[]>([]);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [mapLocation, setMapLocation] = useState({
    lat: 0,
    lng: 0,
  });
  const [countrySearch, setCountrySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => setModalOpen(false);
  const [countries, setCountries] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<any>("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [shareLink, setShareLink] = useState("");
  const [loadingLink, setLoadingLink] = useState(false);
  const [copied, setCopied] = useState(false);
  const [totalRecords, setTotalRecords] = useState<any>(null);
  const isSearching = searchText.trim().length > 0;
  const distributorID : any = localStorage.getItem('distributorId')? Number(localStorage.getItem('distributorId')):undefined;
  const [showEmptyState, setShowEmptyState] = useState(false);

  const {
    debouncedSearch,
    search,
    setSearch,
    pageSelected,
    setPageSelected,
    rowsPerPageValue,
    setRowsPerPageValue,
  } = useSearchPagination();
  
  const columns = useMemo(
    () => [
      // {name:"id",selector:(row:any)=>row.id},
      { name: "Retailer Name", selector: (row: any) => 
      <span className="cursor-pointer text-blue-400" 
      onClick={() => openDrawer(<RetailerDetailsDrawer retailerId={row.id} />)}>{row.name}</span> },
      { name: "Person Name", selector: (row: any) => row.contactName},
      { name: "Designation", selector: (row: any) => row.designation },
      { name: "Email", selector: (row: any) => row.emailId },
      { name: "Phone Number", selector: (row: any) => row.mobileNumber },
      // {
      //   name: "Action",
      //   selector: (row: any) => (
      //     <div className="flex items-center gap-3">
      //       <img
      //         src="/assets/media/Frame.png"
      //         alt="edit"
      //         className="w-5 h-5 cursor-pointer"
      //         onClick={() => EditRetailerRow(row)}
      //       />

      //       <img
      //         src="/assets/media/Group 19026.png"
      //         alt="delete"
      //         className="w-5 h-5 cursor-pointer"
      //         onClick={() => DeleteRetailerRow(row)}
      //       />
      //     </div>
      //   ),
      // },
    ],
    []
  );

  useEffect(() => {
      const params = new URLSearchParams(location.search)
    }, [location.search])

  const handleOpenModal = () => {
    reset(getInitialValues(formConfig));
    setSelectedRow(null);
    setModalOpen(true);
  };

  const EditRetailerRow = async (row: any) => {
    try {
      setSelectedRow(row);

      const res = await AuthService.GetSpecificRetailer(row.id);
      const data = res?.data;
      setValue("companyName", data.companyName);
      setValue("name", data.name);
      setValue("designation", data.designation);
      setValue("emailId", data.emailId);
      setValue("mobileNumber", data.mobileNumber);

      setValue("address", data.address);
      setValue("latitude", data.latitude);
      setValue("longitude", data.longitude);

      setValue("pincode", data.pincode);

      setValue("contactEmail", data.contactEmail);
      setValue("contactNo", data.contactNo);
      setEditModalOpen(true);
    } catch {
      toast.error("Failed to fetch Retailer details");
      setEditModalOpen(false);
    }
  };

  const DeleteRetailerRow = (row: any) => {
    setSelectedRow(row);
    setDeleteModalOpen(true);
  };

  const formConfig = useMemo(
    () => ({
      name: {
        defaultValue: "",
        validations: { required: requiredMessage("Retailer Name") },
        controlType: "input",
        placeholder: "Enter Retailer Name",
        label: "Retailer Name",
        isRequired: true,
        className: styles.fullRow,
      },
      contactName: {
        defaultValue: "",
        validations: { required: requiredMessage("Contact Name") },
        controlType: "input",
        label: "Contact Name ",
        placeholder: "Enter Contact Name",
        isRequired: true,
      },
      designation: {
        defaultValue: "",
        validations: { required: requiredMessage("Designation") },
        controlType: "input",
        label: "Designation",
        placeholder: "Enter Designation",
        isRequired: true,
      },
      emailId: {
        defaultValue: "",
        validations: {
          required: requiredMessage("Email ID"),
          pattern: {
            value: emailRegex,
            message: VALIDATION_ERROR_MESSAGES.EMAIL_FORMAT,
          },
        },
        controlType: "input",
        label: "Email ID",
        placeholder: "Enter Email ID",
        isRequired: true,
      },
      mobileNumber: {
        defaultValue: "",
        validations: mobileValidation,
        controlType: "input",
        label: "Mobile Number",
        placeholder: "Enter Mobile Number",
        isRequired: true,
        props: {
          type: "number",
          onKeyDown: onlyNumbersInput,
        },
      },
      
      address: {
        defaultValue: "",
        validations: { required: requiredMessage("Address") },
        controlType: "input",
        label: "Address",
        isRequired: true,
        onFieldClick: () => setMapModalOpen(true),
        className: styles.fullRow,
      },

      latitude: {
        defaultValue: "",
        controlType: "hidden",
        label: "Latitude",
      },
      longitude: {
        defaultValue: "",
        controlType: "hidden",
        label: "Longitude",
      },
      countryId: {
        defaultValue: null,
        validations: {
          required: {
            value: true,
            message: requiredMessage("Country"),
          },
        },
        options: countries,
        controlType: "select",
        label: "Country",
        isRequired: true,
        isMulti: false,
        isControlled: true,
        onInputChange: (val: string) => setCountrySearch(val),
        noOptionsMessage: () =>
          countrySearch ? "No results found" : "Search Country...",
      },
      stateId: {
        defaultValue: null,
        validations: {
          required: {
            value: true,
            message: requiredMessage("State"),
          },
        },
        options: states,
        controlType: "select",
        label: "State",
        isRequired: true,
        isMulti: false,
        isControlled: true,
        onInputChange: (val: string) => setStateSearch(val),
        noOptionsMessage: () =>
          stateSearch ? "No results found" : "Search State...",
      },
      cityId: {
        defaultValue: null,
        validations: {
          required: {
            value: true,
            message: requiredMessage("City"),
          },
        },
        options: cities,
        controlType: "select",
        label: "City",
        isRequired: true,
        isMulti: false,
        isControlled: true,
        onInputChange: (val: string) => setCitySearch(val),
        noOptionsMessage: () =>
          citySearch ? "No results found" : "Search City...",
      },
      pincode: {
        defaultValue: "",
        validations: { required: requiredMessage("Pincode"),
          pattern: {
            value: zipCodeRegex,
            message: VALIDATION_ERROR_MESSAGES.ZIP_CODE_FORMAT,
          },
         },
        controlType: "input",
        label: "Pincode",
        isRequired: true,
        props: {
          type: "number",
          onKeyDown: onlyNumbersInput,
        }
      },
    }),
    [countries, states, cities]
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchRetiler(searchText);
    }, 1000);

    return () => clearTimeout(timer);
  }, [pageSelected,searchText]);
  const from = (pageSelected - 1) * rowsPerPageValue + 1;
  const to = pageSelected * rowsPerPageValue;

  const fetchRetiler = async (query = "") => {
    try {
      setLoading(true);
      const param = {
        from,
        to,
        searchName: searchText,
        status: ""
      };

      const res = await AuthService.GetRetailerList(param);
      const total = res?.data?.totalRecords ?? 0;
      setTotalRecords(total);
      const approvedItems = res?.data?.items

        .filter((item: any) => item.status === "Approved")
        .map((item: any) => ({
          id: item.id,
          name: item.name,
          contactName: item.contactName,
          designation: item.designation,
          emailId: item.emailId,
          mobileNumber: item.mobileNumber,
          address: item.address,
          latitude: item.latitude,
          longitude: item.longitude,
          cityName: item.cityName,
          stateName: item.stateName,
          countryName: item.countryName,
          pincode: item.pincode,
          contactNo: item.contactNo,
          contactEmail: item.contactEmail,
          rejectedReason: item.rejectedReason,
          distributorId: item.distributorId,
          countryId: item.countryId,
          stateId: item.stateId,
          cityId: item.cityId,
        }));

      setAttendanceData(approvedItems);

      if (!searchText && total === 0) {
        setShowEmptyState(true);   // only when NOT searching
      } else {
        setShowEmptyState(false);
      }

      if (approvedItems.length > 0)
        setDistributorId(approvedItems[0].distributorId);
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const { register, handleSubmit, control, watch, formState, setValue, reset } =
    useForm({
      defaultValues: getInitialValues(formConfig),
      mode: "onChange",
    });

  const selectedType = watch("type");
  const selectedCountryId = watch("countryId");
  const selectedStateId = watch("stateId");
  const selectedCityId = watch("cityId");

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countriesData = await AuthService.getCountries();
        const newCountries = countriesData.map((obj) => ({
          value: obj.countryId,
          label: `${obj.countryCode} ${obj.name}`,
        }));
        setCountries(newCountries);
      } catch (err: any) {
        toast.error("Failed to load countries, please try again.");
      }
    };

    loadCountries();
  }, []);

  useEffect(() => {
    if (!selectedCountryId) return;
    const loadStates = async () => {
      try {
        const stateData = await AuthService.GetState(selectedCountryId);
        const newStates = stateData.map((s: any) => ({
          value: s.stateId,
          label: s.name,
        }));
        if (!editModalOpen) {
          setValue("stateId", null);
          setValue("cityId", null);
        }
        setStates(newStates); // update state options
        setCities([]);
      } catch (err: any) {
        toast.error("Failed to load states");
      }
    };
    loadStates();
  }, [selectedCountryId, setValue]);

  useEffect(() => {
    if (!selectedStateId) return;

    const loadCities = async () => {
      try {
        const cityData = await AuthService.GetCity(selectedStateId);
        const newCities = cityData.map((c: any) => ({
          value: c.cityId,
          label: c.name,
        }));
        setCities(newCities);
      } catch (err: any) {
        toast.error("Failed to load cities");
      }
    };
    loadCities();
  }, [selectedStateId]);

  // useEffect(() => {
  //   if (!selectedCityId) return;

  //   const loadLocality = async () => {
  //     try {
  //       const LocalityData = await AuthService.GetLocality(selectedCityId);
  //       const newLocalities = LocalityData.map((c: any) => ({
  //         value: c.CityId,
  //         label: c.Name,
  //       }));
  //       setLocalities(newLocalities);
  //     } catch {}
  //   };
  //   loadLocality();
  // }, [selectedCityId, setValue]);

  useEffect(() => {
    if (!editModalOpen || !selectedRow || countries.length === 0) return;

    setValue("countryId", selectedRow.countryId, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [editModalOpen, selectedRow, countries, setValue]);

  useEffect(() => {
    if (!editModalOpen || !selectedRow || states.length === 0) return;

    setValue("stateId", selectedRow.stateId, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [editModalOpen, selectedRow, states, setValue]);
  // When edit modal opens
  useEffect(() => {
    if (!editModalOpen || !selectedRow || cities.length === 0) return;

    setValue("cityId", selectedRow.cityId, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [editModalOpen, selectedRow, cities, setValue]);

  const onSubmit = async (values: any) => {
    const payload = {
      name: values.name,
      contactName: values.contactName,
      mobileNumber: values.mobileNumber,
      emailId: values.emailId,
      address: values.address || "",
      latitude: values.latitude,
      longitude: values.longitude,
      cityId: values.cityId,
      stateId: values.stateId,
      countryId: values.countryId,
      distributorId: distributorID,
      pincode: values.pincode,
      designation: values.designation,
      contactNo: "",
      contactEmail: "",
      rejectedReason: "",
      shopName : "",
    };

    try {
      const res = await AuthService.AddRetailer(payload);
      if (res?.status === 200) {
        toast.success(res?.message || "Retailer added successfully");
        setModalOpen(false);
        fetchRetiler();
      } else {
        // API returned failure response
        toast.error(res?.error || "Something went wrong");
      }
    } catch (error: any) {
      const backendMessage =
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";
      toast.error(backendMessage);
    } finally {
    }
  };

  
  const handleSave = (selectedAddress: any) => {
    setMapModalOpen(false);
  };

  const handleSelectLocation = (lat: number, lng: number, addr: string) => {

  setMapLocation({ lat, lng });
  setSelectedAddress(addr);

  // Patch form values
  setValue("address", addr, {
    shouldValidate: true,
    shouldDirty: true
  });

  setValue("latitude", lat);
  setValue("longitude", lng);

  setMapModalOpen(false);

};
  const dynamicFormConfig = (() => {
    const config: any = { ...formConfig };

    if (selectedType === "Retailer") {
      const entries = Object.entries(config);

      const typeIndex = entries.findIndex(([key]) => key === "type");

      const distributorField: [string, any] = [
        "DistributorCode",
        {
          defaultValue: "",
          validations: { required: requiredMessage("Distributor Code") },
          controlType: "input",
          label: "Distributor Code",
          isRequired: true,
        },
      ];

      // Insert DistributorCode after "type"
      entries.splice(typeIndex + 1, 0, distributorField);

      // Convert back to object
      return Object.fromEntries(entries);
    }

    return config;
  })();

  const handleDeleteConfirm = async (selectedRow: any) => {
    try {
      const res = await AuthService.DeleteRetailer(selectedRow);
      if (res?.status === 200 && res?.data === true) {
        toast.success(res?.message || "Deleted successfully");
        setDeleteModalOpen(false);
        fetchRetiler();
      } else {
        toast.error(res?.error || "Something went wrong");
      }
    } catch (error: any) {
      const backendMessage =
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";

      toast.error(backendMessage);
    }
  };

  const onSubmitEdit = async (values: any) => {
    const payload = {
      companyName: values.companyName,
      name: values.name,
      designation: values.designation,
      mobileNumber: values.mobileNumber,
      emailId: values.emailId,
      address: values.address,
      // address: ,
      latitude: values.latitude,
      longitude: values.longitude,
      cityId: values.cityId,
      stateId: values.stateId,
      countryId: values.countryId,
      distributorId: 1,
      pincode: values.pincode,
      // gstNo: ,
      // panNo: ,
      // contactName: ,
      contactNo: values.contactNo,
      contactEmail: values.contactEmail,
      rejectedReason: "",
    };
    try {
      const res = await AuthService.EditRetailer(selectedRow.id, payload);

      if (res?.status === 200 && res?.message) {
        toast.success(res.message || "Warehouse updated successfully");
        fetchRetiler();
        setEditModalOpen(false);
      } else {
        toast.error(res?.error || "Failed to update warehouse");
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const handleGetShareLink = async () => {
    try {
      setLoadingLink(true);

      const url = await AuthService.RetailerReferealLink();

      if (url) {
        setShareLink(url);
        toast.success("Link Generated!");
      } else {
        toast.error("No link received");
      }
    } catch (err) {
      toast.error("Failed to generate link");
    } finally {
      setLoadingLink(false);
    }
  };

  const handleCopy = () => {
    if (!shareLink) return;

    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    toast.success("Link Copied!");

    setTimeout(() => {
      setCopied(false); // reset after 2 sec
    }, 2000);
  };

  const handleMapModalClose =() => {
    setValue("address", "");
    setValue("latitude", "");
    setValue("longitude", "");
    setMapModalOpen(false);
  }

  return (
    <div className="p-5">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <div className="flex items-center justify-between gap-3 w-full">

          <h2 className="text-2xl md:text-lg font-semibold whitespace-nowrap">
            Retailer
          </h2>
          <div className="flex gap-2"> 
          <Tooltip title="Get Retailer Sign Up Link">
            <button
              onClick={handleGetShareLink}
              className={`font-medium ml-2 transition-all duration-200 ${ copied ? "text-blue-600" : "text-blue-600" }`}
              disabled={loadingLink}
            >
              {loadingLink ? "..." : <LinkIcon sx={{ fontSize: 25 }}/>}
            </button>
          </Tooltip>
          {shareLink && (
            <div className="flex items-center gap-2 flex-wrap max-w-full">
              <input
                value={shareLink}
                readOnly
                className="outline-none w-72 text-sm"
              />

              <button
                onClick={handleCopy}
                disabled={copied}
                className="font-medium text-blue-600"
              >
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          )}
          </div>
        </div>

        {!showEmptyState && (
          <div className="flex gap-2 w-full md:w-auto md:items-center">

            <div className="flex-1 md:w-80">
              <CustomHeader
                filter={false}
                search={searchText}
                setSearch={setSearchText}
              />
            </div>

            <button
              onClick={handleOpenModal}
              className="cursor-pointer bg-indigo-500 text-white px-4 py-2 rounded-lg whitespace-nowrap"
            >
              Add Retailer
            </button>
          </div>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-10">
          <span className="text-gray-500 text-sm">Loading retailers...</span>
        </div>
      ) : showEmptyState && !isSearching ? (
        <div className="flex flex-col items-center justify-center mt-20">
          <img src="/assets/media/shopping_9725756.png" className="w-40 h-40 mb-4" />
          <h3 className="text-lg font-semibold mb-2">
            No Retailer added yet
          </h3>
          <p className="text-gray-500 mb-4">
            Add a retailer and kickstart operations
          </p>
          <button
            onClick={handleOpenModal}
            className="px-4 py-2 bg-blue-600 text-white rounded-md"
          >
            Add Retailer
          </button>
        </div>
      ) : (
        <>
        <Table
          columns={columns}
          data={attendanceData ?? []}
        />
        <Pagination
        isPagination={true}
        totalCount={totalRecords ?? 0}
        pageSelected={pageSelected}
        setPageSelected={setPageSelected}
        rowsPerPageValue={rowsPerPageValue}
        setRowsPerPageValue={setRowsPerPageValue}
        customRowsPerPage={false}
      />
        </>
      )}

      <Modal
        modalOpen={modalOpen}
        closeModal={handleCloseModal}
        heading="Add Retailer"
        width="700px"
        saveButtonText="Submit"
        onSave={handleSubmit(onSubmit)}
        isSubmitting={formState.isSubmitting}
      >
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-10">
          <div className={styles.formGrid}>
            {formRenderer(dynamicFormConfig, formState, register, control)}
          </div>
        </form>
      </Modal>

      <Modal
        modalOpen={mapModalOpen}
        closeModal={handleMapModalClose}
        heading="Select Address on Map"
        width="800px"
        // onSave={() => handleSave(selectedAddress)}
        hideaddbutton = {true}
      >
        <MapView
          defaultLat={mapLocation.lat}
          defaultLng={mapLocation.lng}
          onSelectLocation={handleSelectLocation}
          showSearchBar={true}
        />
      </Modal>

      <Modal
        modalOpen={deleteModalOpen}
        closeModal={() => setDeleteModalOpen(false)}
        heading="Delete Retailer"
        width="400px"
        hideHeader={true}
        hideFooter={true}
      >
        <div className="flex flex-col items-center text-center p-4">
          <img src="/assets/media/Delete.png" className="w-14 mb-3" />

          <h2 className="text-lg font-semibold mb-2">Delete Retailer</h2>
          <p className="text-gray-500 mb-6">
            Are you sure you want to delete this Retailer?
          </p>

          <div className="flex gap-4 justify-center">
            <button
              className="px-6 py-2 border rounded-md"
              onClick={() => setDeleteModalOpen(false)}
            >
              Cancel
            </button>

            <button
              className="px-6 py-2 text-white rounded-md"
              style={{ backgroundColor: "#6570FC" }}
              onClick={() => handleDeleteConfirm(selectedRow?.id)}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        modalOpen={editModalOpen}
        closeModal={() => setEditModalOpen(false)}
        heading="Edit Retailer"
        width="800px"
        saveButtonText="Update"
        onSave={handleSubmit(onSubmitEdit)}
      >
        <form className="space-y-10" onSubmit={handleSubmit(onSubmitEdit)}>
          <div className={styles.formGrid}>
            {formRenderer(dynamicFormConfig, formState, register, control)}
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Retailer;
